export const SP_CARGANDO = {value: '__cargando__', label: 'Cargando...'};
export const SP_ERROR = {value: '__error__', label: 'Error'};
export const SP_NO_DATA = {value: '__nodata__', label: 'No existen datos para mostrar'};
